/**
 * @generated SignedSource<<a1340b5476070880ecf23a912d161ac1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedCategoryProducts_personalizationModule$data = {
  readonly " $fragmentSpreads": FragmentRefs<"newArrivalsTracking_personalizationModule">;
  readonly " $fragmentType": "HpSharedCategoryProducts_personalizationModule";
};
export type HpSharedCategoryProducts_personalizationModule$key = {
  readonly " $data"?: HpSharedCategoryProducts_personalizationModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedCategoryProducts_personalizationModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedCategoryProducts_personalizationModule",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "newArrivalsTracking_personalizationModule",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryTitle",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "PersonalizationModule",
  "abstractKey": null
};

(node as any).hash = "f09259d6044f5901a99172799cb2dece";

export default node;
